<template>
  <div class="container-fluid">
    <panel class="no-print" Title="دریافت فایل و مدارک" Des="از طریق این فرم میتوانید فایل های ارسال شده توسط کاربران را دریافت کنید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row">
      <div class="col-md-2 col-12" v-for="(item, key) in ListFile" :key="key">
        <div class="bg-Custom text-center mt-2 rounded py-3 px-3">
          <div class="text-dark">{{ item.fullName }}</div>
          <div class="mt-2">
            <span> کدملی : </span><span>{{ item.codemeli }}</span>
          </div>
          <div class="mt-2" v-if="item.perNo != null">
            <span> پرسنلی : </span><span>{{ item.perNo }}</span>
          </div>
          <div class="mt-2"><button class="btn btn-success w-100" @click="Download(item)">دانلود فایل</button></div>
          <div class="mt-2"><button class="btn btn-outline-danger w-100" @click="Hide(item)">عدم نمایش</button></div>
        </div>
      </div>
      <div class="col-12 mt-3">
        <pagenation :countAll="CountData" :activePage="ActivePage" @newPage="newPage"></pagenation>
      </div>
    </div>
    <loading v-if="loading"></loading>
  </div>
</template>
<script>
import Loading from '../Tools/NetPa/Loading.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import Pagenation from './Pagenation.vue'
export default {
  components: { Panel, Pagenation, Loading },
  data() {
    return {
      loading:false,
      ListFile: [],
      ActivePage:1,
      CountData:0
    }
  },
  methods: {
    GetAttachList() {
      this.loading=true;
      var dataAxios = {
        Method: 'POST',
        Action: 'Attach/GetFile',
        ArryfildValue: {
          tableName: 'FileToAdmin',
          Page: this.ActivePage,
        },
      }
      this.$PostData(dataAxios).then((res) => {
        if (res.status == 'success') {
          this.loading=false;
          this.CountData=res.result.count;
          this.ListFile = res.result.data
        }
        if (res.status == 'not success') {
          this.loading=false;
          this.ListFile = []
          this.$mySweetDefaultTost('جستجـــو ناموفق', 'فایل پیوستی برای درخواست انتخابی یافت نشد', 'warning', 2000)
        }
      })
    },
    Download(item) {
      var fileLink = document.createElement('a')
      fileLink.download = item.filename
      fileLink.href = 'data:application/octet-stream;base64,' + item.binary
      document.body.appendChild(fileLink)
      fileLink.target = '_blank'
      fileLink.click()
    },
    Hide(item) {
      let DataAxios = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Attach/HideAttachUser',
        Token: '',
      }
      var formdata = new FormData()
      formdata.append('wwwtblAttachmentId', item.wwwtblAttachmentId)
      DataAxios.ArryfildValue = formdata
      this.$PostFormData(DataAxios).then((res) => {
        this.GetAttachList()
      })
    },
    newPage(val){
      this.ActivePage=val
      this.GetAttachList()
    }
  },
  mounted() {
    this.GetAttachList()
  },
}
</script>
<style scoped>
.bg-Custom {
  background: #e9e9e9 !important;
  border-right: 2px dashed #5fbccc !important;
  /* border:1px solid #2A3F54 !important; */
}
</style>
